import { Assets, Button } from '@foradevelopment/fora-ui';

import { typedT } from '../../..//i18n/i18n';

export const ChangeButton = ({
  openModal,
  fontSize,
}: {
  openModal: () => void;
  fontSize?: 'small' | 'standard' | 'medium' | undefined;
}) => (
  <Button styleAs="link" onClick={openModal} fontSize={fontSize}>
    <Assets.EditIcon marginRight={5} />
    {typedT('common.edit')}
  </Button>
);

export const AddButton = ({ openModal }: { openModal: () => void }) => (
  <Button styleAs="link" onClick={openModal}>
    <Assets.PlusIcon marginRight={5} />
    {typedT('common.choose')}
  </Button>
);
